<template>
    <div class="page">
        <van-tabs v-model="active">
            <van-tab title="ယခုလ၏ အနိုင်ရရှိသူ">
                <van-list v-model="monthLoading" :finished="monthFinished" finished-text="" @load="_fetchMonth">
                    <table class="rank-table">
                        <thead>
                            <tr>
                                <th>အဆင့်</th><th>အသုံးပြုသူ၏ ID</th><th>ရမှတ်</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in monthList" :key="index">
                                <td class="rank-icon">
                                    <img v-if="index == 0" src="~@/assets/rank-1.png" />
                                    <img v-else-if="index == 1" src="~@/assets/rank-2.png" />
                                    <img v-else-if="index == 2" src="~@/assets/rank-3.png" />
                                    <span v-else>{{index+1}}</span>
                                </td>
                                <td v-if="item.nickname">
                                {{item.nickname}}
                                </td>
                                <td v-else>
                                {{item.mobile}}
                                </td>
                                <td>{{item.score}}</td>
                            </tr>
                        </tbody>
                    </table>
                </van-list>
            </van-tab>
            <!-- <van-tab title="ရာသီအလိုက်(၃လအတွင်းဆုရရှိသူ)">
                <van-list v-model="quarterLoading" :finished="quarterFinished" finished-text="" @load="_fetchQuarter">
                    <table class="rank-table">
                        <thead>
                            <tr>
                                <th>အဆင့်</th><th>အသုံးပြုသူ၏ ID</th><th>ရမှတ်<th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in quarterList" :key="index">
                                <td class="rank-icon">
                                    <img v-if="index == 0" src="~@/assets/rank-1.png" />
                                    <img v-else-if="index == 1" src="~@/assets/rank-2.png" />
                                    <img v-else-if="index == 2" src="~@/assets/rank-3.png" />
                                    <span v-else>{{index+1}}</span>
                                </td>
                                <td v-if="item.nickname">
                                {{item.nickname}}
                                </td>
                                <td v-else>
                                {{item.mobile}}
                                </td>
                                <td>{{item.score}}</td>
                            </tr>
                        </tbody>
                    </table>
                </van-list>
            </van-tab> -->
        </van-tabs>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
import {get} from 'lodash'

export default {
    name: 'Rank',
    data(){
        return {
            active: 0,
            monthLoading: false,
            monthFinished: false,
            quarterLoading: false,
            quarterFinished: false,
            monthPage: 1,
            quarterPage: 1,
            monthList: [],
            quarterList: [],
        }
    },
    computed: {
        ...mapState(['lang,langMap'])
    },
    created(){
    },
    methods: {
        _fetchMonth(){
            Utils.$ajax({
                type: 'post',
                url: `/rank/month&page_id=${this.monthPage}&page_size=10`,
            }).done(res=>{
                let list = get(res, 'data.list', []);
                if(res.code != 0){
                    this.$toast(res.msg);
                    this.monthFinished = true;
                    return;
                }
                if(list.length < 10){
                    this.monthFinished = true;
                }
                this.monthPage ++;
                this.monthList = this.monthList.concat(res.data.list);
            }).always(res=>{
                this.monthLoading = false;
            })
        },
        _fetchQuarter(){
            Utils.$ajax({
                type: 'post',
                url: `/rank/quarter&page_id=${this.quarterPage}&page_size=10`,
            }).done(res=>{
                let list = get(res, 'data.list', []);
                if(res.code != 0){
                    this.quarterFinished = true;
                    this.$toast(res.msg);
                    return;
                }
                if(list.length < 10){
                    this.quarterFinished = true;
                }
                this.quarterPage ++;
                this.quarterList = this.quarterList.concat(res.data.list);
            }).always(res=>{
                this.quarterLoading = false;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        height: 100%;
        background: #fff;
        margin: 0 .6em;
    }
    .page /deep/ .van-tabs__line{
        display: none;
    }
    .page /deep/ .van-tabs__content{
        border: 2px #000 solid;
    }
    .page /deep/ .van-tab{
        color: #000;
        border: 1px #000 solid;
        border-radius: 5px;
        &.van-tab--active{
            background-color: #576db3;
        }
    }
    .rank-table{
        width: 100%;
        text-align: center;
        font-size: rem(30);
        td, th{
            border-bottom: 1px rgba(255,255,255,.6) dashed;
            padding: .4em 0;
        }
        .num{
            width: rem(40);
            height: rem(40);
            border-radius: 50%;
            background: #c37600;
        }
        .rank-icon{
            img{
                width: rem(49);
                height: rem(87);
            }
            span{
                display: inline-block;
                width: rem(53);
                height: rem(53);
                border-radius: 50%;
                background: #82807e;
                color: #fff;
                line-height: rem(53);
                text-align: center;
            }
        }
    }
    @keyframes pulldown
    {
        from {transform: translateY(0);}
        to {transform: translateY(50%);}
    }
</style>



// WEBPACK FOOTER //
// src/components/Rank.vue